import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextTooltipProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextTooltip = ({
  label,
  color = 'text-ds-natural',
  ellipsis,
}: TextTooltipProps) => (
  <Typography
    color={color}
    label={label}
    ellipsis={ellipsis}
    tagName="span"
    fontSize="text-ds-90"
    lineHeight="leading-ds-100"
    fontWeight="font-ds-normal"
    letterSpacing="tracking-ds-tight"
  />
);
